import * as React from "react";
import {Project} from "../../../../../domain/model/project";
import styled from "styled-components";
import {ConstBorderRound} from "../../../../../config/styles_const/styles_const";

interface IProps {
    project: Project;
}

const ProjectThumbnail: React.FC<IProps> = (props) => {

    const {project} = props;

    const projectThumbnailURL: string = project.getThumbnailURL();

    return(
        <Wrapper>
            <Thumbnail src={projectThumbnailURL} />
        </Wrapper>
    )
};

export default ProjectThumbnail

const Wrapper = styled.div`
    margin-bottom: 50px;
`;

const Thumbnail = styled.img`
    height: 280px;
    width: 100%;
    object-fit: cover;
    border-radius: ${ConstBorderRound.CornerRoundAll};
`;



// WEBPACK FOOTER //
// ./src/presentation/component/client/contract/share/project_thumbnail.tsx